import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import type { ReactNode } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  allTo?: string
  allHref?: string
  children: ReactNode
  variant?: React.ComponentProps<typeof Heading>['variant']
}

function OfferCarouselHeader(props: Props) {
  const { allTo, allHref, children, variant = 'heading2' } = props
  const intl = useIntl()

  const viewAllText = intl.formatMessage({
    id: 'wKX6uaWtjZ',
    defaultMessage: 'View all',
    description: 'Button text to view all items in a carousel',
  })

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="start" gap={16}>
      <Heading variant={variant}>
        {children}
      </Heading>
      {!!(allTo || allHref) && <Group direction="horizontal" gap={16} verticalAlign="center">
        <TextButton kind="tertiary" size="medium" to={allTo} href={allHref}>
          {viewAllText}
        </TextButton>
      </Group>}
    </Group>
  )
}

export default OfferCarouselHeader
